<div
  class="gw-mt-6 gw-border-base gw-bg-background-elevation-2 md:gw-rounded-2xl"
  *ngIf="whiteListSplit.length > 0"
>
  <div
    class="gw-border-content-header gw-border-0 gw-border-b gw-border-b-[1px] gw-border-b-border-normal gw-border-solid gw-bg-background-neutral-1 gw-h-[56px] gw-flex gw-justify-between gw-items-center gw-px-4 md:gw-px-6"
  >
    <p class="gw-text-[16px] gw-text-text-primary gw-font-bold">
      {{ 'common.splitPayment.title' | translate }}
    </p>
    <gatewee-button
      [title]="'common.splitPayment.add' | translate"
      variant="secondary"
      iconName="@tui.plus"
      class="gw-w-full gw-max-w-[120px] md:gw-max-w-[124px]"
      (clicked)="addSplitForm()"
    ></gatewee-button>
  </div>

  <div
    class="gw-mt-4 gw-flex gw-flex-col gw-gap-medium gw-px-4 md:gw-px-6 gw-pb-4"
  >
    <div
      *ngIf="emptySplit"
      class="gw-flex gw-flex-col md:gw-flex-row gw-gap-medium gw-border-base gw-items-center gw-bg-background-elevation-3 gw-px-[16px] gw-py-[16px] gw-rounded-2xl"
    >
      <gatewee-icon
        icon="@tui.info"
        iconStyle="outline"
        size="24px"
      ></gatewee-icon>
      <div class="gw-col">
        <p class="gw-text-text-secondary gw-text-[16px] gw-font-bold">
          {{ 'common.splitPayment.emptyTitle' | translate }}
        </p>
        <p class="gw-text-text-secondary">
          {{ 'common.splitPayment.emptyHint' | translate }}
        </p>
      </div>
    </div>

    <div
      *ngFor="let form of formArray.controls; let i = index"
      class="gw-border-base gw-bg-background-elevation-3 gw-px-[16px] gw-py-[16px] gw-rounded-2xl"
    >
      <ng-container *ngIf="!saved[i]; else savedView">
        <form [formGroup]="form" class="gw-rounded-2xl">
          <div class="gw-form-row-md-center">
            <div class="gw-w-full md:gw-flex-1">
              <gatewee-select-v3
                [label]="'common.splitPayment.recipient' | translate"
                id="recipient-{{ i }}"
                [items]="whiteListSplit"
                formControlName="recipientId"
                [placeholder]="
                  'common.splitPayment.recipientPlaceholder' | translate
                "
              ></gatewee-select-v3>
            </div>
            <div class="gw-w-full md:gw-flex-1">
              <div
                class="gw-mb-[12px] gw-flex gw-items-center gw-gap-x-small gw-text-[14px] gw-font-bold gw-text-text-primary"
              >
                <span>{{ 'common.splitPayment.paymentType' | translate }}</span>
                <gatewee-icon
                  icon="@tui.info"
                  iconStyle="primary"
                  size="16px"
                  matTooltipPosition="above"
                  class="gw-shrink-0 gw-text-[#2B7FFF] gw-inline-flex gw-leading-none"
                ></gatewee-icon>
              </div>
              <div class="gw-flex gw-gap-x-large gw-items-center">
                <gatewee-radio-button
                  formControlName="type"
                  [label]="'common.splitPayment.fixedValue' | translate"
                  name="type-{{ i }}"
                  [value]="'fixed'"
                  (change)="setSplitType(i, 'fixed')"
                >
                </gatewee-radio-button>
                <gatewee-radio-button
                  formControlName="type"
                  [label]="'common.splitPayment.percentage' | translate"
                  name="type-{{ i }}"
                  [value]="'percentage'"
                  (change)="setSplitType(i, 'percentage')"
                >
                </gatewee-radio-button>
              </div>
            </div>
            <div class="gw-w-full md:gw-flex-1">
              <gatewee-input-v2
                [form]="form"
                [label]="'common.splitPayment.amount' | translate"
                controlName="amount"
                [format]="
                  form.get('type')?.value === 'fixed' ? 'currency' : 'percent'
                "
                type="currency"
                [placeholder]="
                  'common.splitPayment.amountPlaceholder' | translate
                "
                [iconName]="
                  form.get('type')?.value === 'fixed'
                    ? '@tui.circle-dollar-sign'
                    : '@tui.circle-percent'
                "
                [customMessages]="{
                  notMoreThan100:
                    ('common.splitPayment.validation.maxPercent' | translate)
                }"
              ></gatewee-input-v2>
            </div>
            <div class="gw-form-inline-field-actions__action">
              <gatewee-button
                [title]="'common.actions.save' | translate"
                variant="primary"
                class="gw-w-full md:gw-max-w-[80px] gw-text-[14px]"
                [disabled]="form.invalid"
                (clicked)="saveSingle(i)"
              ></gatewee-button>
            </div>
          </div>
        </form>
      </ng-container>

      <ng-template #savedView>
        <div
          class="gw-flex gw-bg-background-elevation-3 gw-flex-col md:gw-flex-row gw-items-start md:gw-items-center gw-justify-between gw-gap-medium"
        >
          <div
            class="gw-flex gw-flex-col md:gw-flex-row gw-self-start md:gw-self-unset gw-items-start md:gw-items-center gw-gap-4"
          >
            <gatewee-icon
              icon="@tui.trash"
              iconStyle="primary"
              size="20px"
              class="gw-hidden md:gw-block gw-border gw-border-solid gw-border-icon-primary gw-rounded-lg gw-p-2 gw-cursor-pointer"
              (click)="removeSplit(i)"
            ></gatewee-icon>
            <div
              class="gw-flex gw-flex-col md:gw-flex-row md:gw-gap-[48px] gw-gap-[24px]"
            >
              <div>
                <p class="gw-font-bold gw-text-text-primary">
                  {{ 'common.splitPayment.recipient' | translate }}
                </p>
                <p class="gw-text-text-secondary">
                  {{ showRecipient(formSaved[i]) }}
                </p>
              </div>

              <div>
                <p class="gw-font-bold gw-text-text-primary">
                  {{ 'common.splitPayment.paymentTypeShort' | translate }}
                </p>
                <p class="gw-text-text-secondary">
                  {{
                    formSaved[i]?.type === 'fixed'
                      ? ('common.splitPayment.type.fixed' | translate)
                      : formSaved[i]?.type === 'percentage'
                      ? ('common.splitPayment.type.percentage' | translate)
                      : ('common.splitPayment.type.notInformed' | translate)
                  }}
                </p>
              </div>

              <div>
                <p class="gw-font-bold gw-text-text-primary">
                  {{ 'common.splitPayment.amount' | translate }}
                </p>
                <p class="gw-text-text-secondary">
                  {{ showValue(formSaved[i]) }}
                </p>
              </div>
            </div>
          </div>

          <gatewee-button
            [title]="'common.actions.edit' | translate"
            variant="outline"
            class="gw-w-full md:gw-w-[104px] gw-text-[14px]"
            (clicked)="edit(i)"
            [iconName]="'@tui.pencil'"
          ></gatewee-button>
          <gatewee-button
            [title]="'common.actions.remove' | translate"
            variant="outline"
            class="gw-flex gw-w-full gw-text-[14px] gw-text-brand-primary md:gw-mt-0 md:gw-hidden md:gw-w-[104px] gw-border gw-border-solid gw-border-brand-primary"
            (clicked)="removeSplit(i)"
            iconName="@tui.trash"
          ></gatewee-button>
        </div>
      </ng-template>
    </div>
  </div>
</div>
